import styled from 'styled-components';

import variables from '../../styles/variables';

export const StoreListTitle = styled.div`
  width: 574.98px;
  height: 25px;
  font-weight: 600;
  font-size: 18px;
  line-height: 30px;
  color: ${variables.colorBlack};
  margin-bottom: 16px;
`;

export const HeaderInnerContainer = styled.div`
  width: 100%;
  display: flex;
  &.locale {
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding: 10px 2.5rem;
    @media screen and (max-width: 1023px) {
      padding: 10px 1.25rem;
    }
  }
  &.navigation {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px 2.5rem;
    @media screen and (max-width: 1023px) {
      padding: 10px 1.25rem;
    }
  }
`;
